/**
 * HTML编译输出过滤器
 */

// 折扣展示
export const discount = (value) => {
  let discount = value.split('.')[0];
  if(discount % 10 == 0){
  	return discount.substr(0,1);
  }else {
  	return discount;
  }
}

/**
 * 日期格式化
 * @param timeSpan
 * @param format
 * @returns {*}
 */
export function dateFormat(timeSpan, format) {
  if (!timeSpan) return;

  //兼容IE8低版本处理
  let timestr = timeSpan.replace(/-/g, '/').replace(/T|Z/g, ' ').trim();

  let date = new Date(timestr);
  let o = {
    "M+": date.getMonth() + 1, //month
    "d+": date.getDate(), //day
    "h+": date.getHours(), //hour
    "m+": date.getMinutes(), //minute
    "s+": date.getSeconds(), //second
    "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
    "S": date.getMilliseconds() //millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }

  return format;
}



// WEBPACK FOOTER //
// ./src/filters/index.js